import axios from "axios";

export const API = axios.create({
  //baseURL: "http://127.0.0.1:3010/",
 baseURL: "https://www.abyarinovin.ir/api/",
  headers: {
    "Content-Type": "application/json", // این باعث preflight میشه
  },
});
API.interceptors.request.use((config) => {
  // اگر مسیر (url) یکی از مسیرهایی بود که نباید توکن داشته باشه، توکن اضافه نکن
  const noAuthRoutes = [
    "user/login",
    "user/validate",
    "user/password/reset",
    "user/regions",
    "user/region/${id}",
  ];

  if (!noAuthRoutes.includes(config.url)) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// لاگین
export const login = (credentials) => API.post("user/login", credentials);
export const fetchUserWell = () => API.get("user/well"); // فرضی برای دریافت اطلاعات بیشتر کاربر

export const fetchReportCommandCount = (data) =>
  API.post(`report/command/count`,data);

export const fetchReportCommandList= (data) =>
  API.post(`report/command/list`,data);

export const fetchProgramList = (id) => API.get(`equipment/${id}/program/list`);

export const getLastExpenseWaterforWell =async (id) =>{
const res=await API.get(`report/well/expense/water/${id}`);
return res.data
} 

export const fetchStatusWell = (id) => API.get(`equipment/${id}/status`);

export const fetchReportFlowmeter = async(credentials) =>{
 return await API.post(`report/flowmeter`, credentials);
}
// ارسال کد فراموشی رمز عبور
export const validateUser = async (user) => {
  const res = await API.post("user/validate", user);
  return res.data.serverID;
};
export const getRegions = async () => {
  const res = await API.get(`user/regions`);
  return res.data; // فقط آرایه مناطق رو برگردون
};

export const getArea = async (id) => {
  const res = await API.get(`user/region/${id}`);
  return res.data; // فقط آرایه مناطق رو برگردون
};
export const registerUser = (credentials) =>
  API.post("user/register", credentials);
/*
export const checkVerifyCode = async(mobile) => {
  const res = API.post("check/verifycode'", { mobile });
  return res.data
};*/
// ارسال رمز جدید برای ریست پسورد
export const resetPassword = (data) => {
  // data میتونه شامل { token, email, password, password_confirmation } باشه
  return API.post("user/password/reset", data);
};
export const getWellUserDetails = async (id) => {
  const res = await API.get(`user/local/${id}`);
  return res.data; // فقط آرایه مناطق رو برگردون
};
